import { BusEventBase, BusEventWithPayload } from '@grafana/data';
import { type SceneObjectUrlValues } from '@grafana/scenes';

export const VAR_FILTERS = 'filters';
export const VAR_FILTERS_EXPR = '${filters}';
export const VAR_METRIC = 'metric';
export const VAR_METRIC_EXPR = '${metric}';
export const VAR_GROUP_BY = 'groupby';
export const VAR_DATASOURCE = 'ds';
export const VAR_DATASOURCE_EXPR = '${ds}';
export const VAR_LOGS_DATASOURCE = 'logsDs';
export const VAR_LOGS_DATASOURCE_EXPR = '${logsDs}';
export const VAR_OTHER_METRIC_FILTERS = 'other_metric_filters';

export const LOGS_METRIC = '$__logs__';

export const trailDS = { uid: VAR_DATASOURCE_EXPR };

export type MakeOptional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

type MetricSelectedEventPayload = {
  metric?: string;
  urlValues?: SceneObjectUrlValues;
};

export class MetricSelectedEvent extends BusEventWithPayload<MetricSelectedEventPayload> {
  public static readonly type = 'metric-selected-event';
}

export class RefreshMetricsEvent extends BusEventBase {
  public static readonly type = 'refresh-metrics-event';
}
